import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Typography, Flex } from 'antd';
import { setHeroTitle, setHeroContent, setHeroImage } from '../../redux/hero.slice'
const { Title, Paragraph } = Typography;

import ArrowButton from '../../shared/ArrowButton/ArrowButton';

import Conatiner from '../../shared/Conatiner/Container';
import Timeline from '../../shared/Timeline/Timeline';
import Quote from '../../shared/Quote/Quote'
import FeatureList from '../../shared/FeatureList';
import RelatedPulseLinks, { relatedPulseArticles } from '../../shared/RelatedPulseLinks';

import PegBoardHighlight from '../Home/PegBoardHighlight';

import useMobileCheck from '../../mobile';

const PegboardPage = () => { 
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setHeroImage(false));
    dispatch(setHeroTitle(`Take the guess work out of who plays next`))
    dispatch(setHeroContent(`Tired of the random chaos of pick-up games? The ShuttleOps Digital Peg Board takes the guesswork out of who plays next. Players get fair, rotating court time, clubs get better-managed sessions, and everyone gets more time on court — with better matchups, every time.`))
  }, [dispatch]);

  const { isMobile } = useMobileCheck();

  const pegBoardTimeline = [ 
    { 
      title : "Setup club parameters",
      description: "Club admins perform a one time setup adding locations, courts and costs for sessions. "
    }, 
    { 
      title: "Create a session", 
      description: "Those with the necessary persmissions can create the sessions for a given date and time. Tweak parameters such as maximum players, courts and location for this session before saving. Your players can now register to participate in this session."
    }, 
    { 
      title: "Session starts", 
      description: "During the session add player attendance using the app so that they can be allocated to games. "
    }, 
    { 
      title: "Create games", 
      description: "Use the automated functionality to add players to free couts fairly and easily. Track results at the end of the game."
    },
    { 
      title: "Track metrics", 
      description: "Following the session all game and player metrics are emailed to players. "
    }
  ]

  const clubBenefits = [
    {
      title: 'Optimise bookings',
      description: 'More games per session & less faffing between matches means options for having more club members.',
    },
    {
      title: 'Fair Play Assurance',
      description: 'A fair, modern system will attract modern and likeminded players. ',
    },
    {
      title: 'All involved',
      description: "Simple process means anyone can do it, meaning everyone helps with court allocation.",
    }
  ];

  const playerBenefits = [
    {
      title: 'Fair Play',
      description: 'Smarter, varied matchups across different skill levels. Everyone plays equal amounts.',
    },
    {
      title: 'Match History & Stats',
      description: "Keep track of your match history and view playing stats to help you play better.",
    },
    {
      title: 'Increased game time',
      description: "Efficient game time means you get more court time for your club membership fees.",
    }
  ];
  
  return ( 
    <Flex vertical 
      style={{ 
        paddingTop: 20,
        paddingBottom: 20
      }}
      gap={20}>
      <PegBoardHighlight
        gutter={{
          xs: [0, 24],
          xl: [0, 10],
        }}
        style={{ marginTop: 20, paddingRight: 20 }}
        classname="pegboard-main"
        >
        <Paragraph
          style={{ 
            fontSize: '1rem'
          }}
        >
          A better peg board isn't just for a club, or just for the players. Having a system that is designed with both in mind helps everyone, here is how. </Paragraph>
        <Flex gap={20}
          vertical={isMobile}
          style={{ width: '100%', padding: '20px' }}
          >
          <FeatureList 
            small={true}
            style={{ width: isMobile ? '100%' : '50%' }}
            heading="For Clubs" 
            items={clubBenefits} />
          <FeatureList
            small={true}
            style={{ width: isMobile ? '100%' : '50%' }}
            heading="For Players" 
            items={playerBenefits} />
        </Flex>
        <RelatedPulseLinks articles={relatedPulseArticles.pegboard} />
      </PegBoardHighlight>

      <Conatiner
        colour="white"
        >
        <Flex 
          wrap
          style={{ 
            padding: isMobile ? '10px' : '0px 40px 40px 40px'
          }}
          >
          <Timeline timeline={ pegBoardTimeline } title="How It Works"/>
        </Flex>
      </Conatiner>

      <Flex 
        vertical={ isMobile }
        gap={20}>
        <Quote
          style={{ background: 'white' }}
          quote={"Working out fair games during a badminton session is always difficult. ShuttleOps makes this so much easier, tracking who has played with whom, so players have a much more varied set of games. I have had lots of positive feedback from players enjoying the greater variety of games."}
          name={"Martin Hyett"}
          title={"Club Manager, Hiltingbury Badminton Club"}
          stars={5}
          />
        <Quote
          style={{ background: 'white' }}
          quote={"ShuttleOps has completely transformed the way we manage our badminton club. Scheduling, payments, and attendance tracking are now effortless, allowing us to focus on what truly matters-building a thriving community and enhancing player experience."}
          name={"Mark Jensen"}
          title={"Club Manager, Elite Badminton Academy"}
          stars={4}
          />
      </Flex>
    </Flex>
  )
}

export default PegboardPage;
